import {ROUTE_LOGIN, ROUTE_LOGIN_LOGOUT} from '../../application/constants'

export default [
  {
    path: ROUTE_LOGIN,
    children: [
      {
        path: '',
        loadComponent: () => import('./login/login.component')
          .then(c => c.LoginComponent)
      },
      {
        path: ROUTE_LOGIN_LOGOUT,
        loadComponent: () => import('./logout/logout.component')
          .then(c => c.LogoutComponent)
      },
      {
        path: '**',
        redirectTo: ''
      }
    ]
  }
]
